import GenericVModel from '@components/mixins/genericVModel'
import Message from 'element-ui/lib/message'
import { mapActions } from 'vuex'

export default {
  name: 'EditBlockUpload',
  mixins: [GenericVModel],
  props: {
    enableRemoveImage: {
      required: false,
      default: false,
    },
  },
  data() {
    return {
      uploadInProgress: false,
      fileList: [
        {
          name: 'Remove Image',
        },
      ],
    }
  },
  methods: {
    ...mapActions('editor', ['uploadFile']),
    uploadStart(file) {
      this.uploadInProgress = true

      this.uploadFile(file)
        .then((imageURL) => {
          this.input = imageURL
          this.fileList = []
          this.fileList.push({ name: 'Remove Image' })
          this.uploadInProgress = false
        })
        .catch(() => {
          Message.error({
            message: "Couldn't upload image, please contact our help center!",
          })
        })
    },
    beforeUpload(file) {
      const isIMG =
        file.type === 'image/gif' || file.type === 'image/jpeg' || file.type === 'image/png'
       || file.type === 'image/webp'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isIMG) {
        Message.error({ message: 'Image must be JPG, PNG, WEBP or GIF format!' })
      }

      if (!isLt2M) {
        Message.error({ message: 'Image size can not exceed 2MB!' })
      }

      return isIMG && isLt2M
    },
    removeCurrentImage(file, fileList) {
      this.input = ''
      this.fileList = []
    },
  },
}
